import { ReportChartConfiguration } from '@vision/ui/interfaces';
import { PieChart3CompareRenderer } from '../../components';
import { PieChartFcrValueComponent } from '../../components/ReportsDetailGraphicChartsRenderer';
import {
  hideCompareForPieChartFcr,
  hideFiltersForFcr,
  PieChartFcrCustomizeDefaults,
  PieChartFcrValidationParams,
} from '../pie-chart-fcr.config';
import {
  DefaultReportChartThemeFont,
  DefaultReportChartThemeSeries,
  extendDefaultChartValidationSchema,
} from '../default-chart.config';
import { PieChart3Measures } from './pie-chart3.measures';

export const PieChart3DefaultConfiguration: ReportChartConfiguration = {
  supportsLegendSettings: true,
  validationSchema: extendDefaultChartValidationSchema({
    params: PieChartFcrValidationParams,
  }),
  measures: PieChart3Measures,
  compareRendererComponent: PieChart3CompareRenderer,
  chartValueComponent: PieChartFcrValueComponent,
  hideCompareCondition: hideCompareForPieChartFcr,
  hideFiltersCondition: hideFiltersForFcr,
  compareHeader: {
    labelKey: 'page-reports:compare',
    showIcon: false,
  },
  measureHeader: {
    labelKey: 'page-reports:measurement',
    showIcon: false,
  },
  customize: {
    active: (values) => !!values.selectedMeasure && values.selectedCompare.length > 0,
    transactionalDate: {
      active: false,
    },
    feedbackCount: {
      active: false,
    },
    limits: {
      upperLimitActive: false,
      upperLimit: 0,
      lowerLimitActive: false,
      lowerLimit: 0,
    },
    ...PieChartFcrCustomizeDefaults,
  },
  defaultTheme: {
    active: (values) => !!values.selectedMeasure && values.selectedCompare.length > 0,
    title: {
      ...DefaultReportChartThemeFont,
      label: '',
    },
    dataLabels: {
      ...DefaultReportChartThemeFont,
      active: true,
      hideFormatPosition: true,
      hideDataLabelColorize: true,
      displayFormat: 'auto',
      labelDisplayFormat: 'number',
    },
    series: {
      ...DefaultReportChartThemeSeries,
    },
  },
};
